import i18n from '../i18n'
import type { OfflineEntity } from './db'

export function entityLabel(entity: OfflineEntity): string {
  return i18n.t(`syncEntities.${entity}`)
}
